import { fmtDate } from "./format";

/** Solo avisar a usuarios cuando faltan estos días o menos (inclusive). */
export const SUBSCRIPTION_WARN_WITHIN_DAYS = 30;

function diasRestantes(org) {
  if (org.dias_restantes != null) return org.dias_restantes;
  if (!org.vigente_hasta) return null;
  const fin = new Date(org.vigente_hasta);
  if (Number.isNaN(fin.getTime())) return null;
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  fin.setHours(0, 0, 0, 0);
  return Math.max(0, Math.ceil((fin - hoy) / (1000 * 60 * 60 * 24)));
}

/**
 * Mensaje de vigencia de la organización para usuarios (no demo / sin límite).
 * @returns {{ level: 'info'|'warn'|'urgent'|'danger', title: string, detail: string } | null}
 */
export function getSubscriptionNotice(org) {
  if (!org || org.sin_limite || org.es_demo) return null;

  const hasta = org.vigente_hasta;
  const dias = diasRestantes(org);

  if (!org.activa) {
    return {
      level: "danger",
      title: "Cuenta suspendida",
      detail:
        "El acceso de su organización fue suspendido. Contacte al administrador del sistema.",
    };
  }

  if (!hasta && dias == null) return null;
  if (dias != null && dias > SUBSCRIPTION_WARN_WITHIN_DAYS) return null;

  const fecha = fmtDate(hasta);
  const diasLabel =
    dias === 0
      ? "hoy"
      : dias === 1
        ? "1 día"
        : `${dias} días`;

  let level = "info";
  if (dias != null) {
    if (dias <= 3) level = "urgent";
    else if (dias <= 14) level = "warn";
    else if (dias <= SUBSCRIPTION_WARN_WITHIN_DAYS) level = "info";
  }

  return {
    level,
    title:
      dias === 0
        ? "Su acceso vence hoy"
        : `Quedan ${diasLabel} de acceso`,
    detail: `La suscripción de ${org.nombre || "su organización"} vence el ${fecha}.`,
  };
}

export const SUBSCRIPTION_STYLES = {
  info: "bg-primary/10 border-primary/20 text-primary",
  warn: "bg-amber-50 border-amber-200/80 text-amber-950",
  urgent: "bg-orange-50 border-orange-200/80 text-orange-950",
  danger: "bg-red-50 border-destructive/30/80 text-red-900",
};
